import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody } from 'reactstrap'
import PropTypes from 'prop-types'
import { verifyLength } from '../../../helper'
import { addCMS } from '../../../actions/cms'
import warningIcon from '../../../assests/images/warning-icon.svg'
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document'
import CKEditor from '@ckeditor/ckeditor5-react'

function AddCMSForm (props) {
  const [loading, setLoading] = useState(false)
  const [Title, setTitle] = useState('')
  const [errTitle, seterrTitle] = useState('')
  const [errSlug, seterrSlug] = useState('')
  const [Details, setDetails] = useState('')
  const [errDetails, seterrDetails] = useState('')
  const [message, setMessage] = useState('')
  const [Slug, setSlug] = useState('')

  const dispatch = useDispatch()
  const token = useSelector(state => state.auth.token)
  const resStatus = useSelector(state => state.cms.resStatus)
  const resMessage = useSelector(state => state.cms.resMessage)
  const previousProps = useRef({ resStatus, resMessage }).current
  // const page = JSON.parse(localStorage.getItem('queryParams'))

  const [modalMessage, setModalMessage] = useState(false)
  const toggleMessage = () => setModalMessage(!modalMessage)

  useEffect(() => {
    if (previousProps.resMessage !== resMessage) {
      if (resMessage) {
        setMessage(resMessage)
        if (resStatus) {
          props.history.push('/cms/cms-management', { message: resMessage })
        } else {
          setModalMessage(true)
        }
      }
    }
    setLoading(false)
    return () => {
      previousProps.resMessage = resMessage
    }
  }, [resStatus, resMessage])

  function onSubmit (e) {
    e.preventDefault()
    if (verifyLength(Slug, 1) && verifyLength(Title, 1) && verifyLength(Details, 1) && !errDetails && !errSlug && !errTitle) {
      dispatch(addCMS(Slug, Title, Details, token))
      setLoading(true)
    } else {
      if (!verifyLength(Slug, 1)) {
        seterrSlug('Required field')
      }
      if (!verifyLength(Title, 1)) {
        seterrTitle('Required field')
      }
      if (!verifyLength(Details, 1)) {
        seterrDetails('Required field')
      }
    }
  }

  function handleChange (event, type) {
    switch (type) {
      case 'Slug':
        if (verifyLength(event.target.value, 1)) {
          seterrSlug('')
        } else {
          seterrSlug('Required Field')
        }
        setSlug(event.target.value)
        break
      case 'Title':
        if (verifyLength(event.target.value, 1)) {
          seterrTitle('')
        } else {
          seterrTitle('Required Field')
        }
        setTitle(event.target.value)
        break
      default:
        break
    }
  }

  function onEditorChange (evt, editor) {
    if (verifyLength(editor.getData(), 1)) {
      seterrDetails('')
    } else {
      seterrDetails('Required Field')
    }
    setDetails(editor.getData())
  }

  return (
    <main className="main-content">
    {loading}
   <section className="common-form-block">
     <h2>Add CMS</h2>
     <Form onSubmit={onSubmit}>
      <FormGroup>
         <Label for="slug">Slug</Label>
         <Input name="slug" placeholder="Slug" value={Slug} onChange={event => handleChange(event, 'Slug')} />
         <p className="error-text">{errSlug}</p>
      </FormGroup>
       <FormGroup>
         <Label for="title">Title</Label>
         <Input name="title" placeholder="Title" value={Title} onChange={event => handleChange(event, 'Title')} />
         <p className="error-text">{errTitle}</p>
       </FormGroup>
       <FormGroup>
       <Label for="status">Details</Label>
       <CKEditor
         onInit={(editor) => {
           editor.ui.getEditableElement().parentElement.insertBefore(
             editor.ui.view.toolbar.element,
             editor.ui.getEditableElement()
           )
         }}
         editor={DecoupledEditor}
         data={Details}
         onChange={onEditorChange}
       />
       <p className="error-text">{errDetails}</p>
       </FormGroup>
       <Button className="theme-btn full-btn">Submit</Button>
       {/* <div className="form-footer text-center small-text">
          <NavLink to={`/cms/cms-management${page.CMSMnagement}`}>Cancel</NavLink>
        </div> */}
     </Form>
   </section>
   <Modal isOpen={modalMessage} toggle={toggleMessage} className="modal-approve">
     <ModalBody className="text-center">
       <img className="info-icon" src={warningIcon} alt="check" />
       <h2>Failed</h2>
       <p className="small-text light-text">{message}</p>
       <Button type="submit" className="theme-btn danger-btn full-btn" onClick={toggleMessage}>OK</Button>
     </ModalBody>
   </Modal>
 </main>
  )
}
AddCMSForm.propTypes = {
  history: PropTypes.object
}
export default AddCMSForm
